import React, { Component, ErrorInfo, ReactNode } from 'react';
import AudioPlayer from './AudioPlayer';

interface AudioPlayerWrapperState {
  hasError: boolean;
}

/**
 * Wrapper component to catch any errors in AudioPlayer
 * and silently hide it instead of crashing the app
 */
class AudioPlayerWrapper extends Component<{}, AudioPlayerWrapperState> {
  constructor(props: {}) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): AudioPlayerWrapperState {
    // Silently catch errors and hide the player
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    // Log error silently without showing to user
    console.warn('AudioPlayer error (silently handled):', error, errorInfo);
  }

  render(): ReactNode {
    if (this.state.hasError) {
      // Silently return null if there's an error
      return null;
    }

    return <AudioPlayer />;
  }
}

export default AudioPlayerWrapper;

